import TileAnimation from "./TileAnimation.js";

export default class Spike extends TileAnimation {
	constructor(sp, cell, tile, level) {
		super(sp, cell, tile, level, Spike.ANIMATIONS)
		this.clas = "Spike";
		//this.target.css("top",-8)
		//this.initKind();
		this.idTo = -1;
		this.status = 0
		this.operating = false;
		this.canHarm = false;
	}

	deinitSpikes() {
		if (this.status !== 0) {
			clearTimeout(this.idTo);
			this.status = 0;
			this.setAnimation("off");
		}

	}
	initSpikes() {
		let kind = this.cell.spikeKind;
		if (kind === "prox") {

		} else if (kind === "slow") {
			this.idTo = setTimeout(this.nextStatus.bind(this),100)
		} else if (kind === "fast") {
			this.idTo = setTimeout(this.nextStatus.bind(this), 100)
		} else if (kind === "double") {
			this.idTo = setTimeout(this.nextStatus.bind(this), 100)
		}
	}

	isProx() {
		let kind = this.cell.spikeKind;
		if (kind === "prox") {
			return true;
		}
		return false;
	}

	nextStatus() {
		clearTimeout(this.idTo);
		let kind = this.cell.spikeKind;
		this.status++;
		if (this.status > 2) {
			this.status = 1;
		}

		if (this.status === 1) {
			this.setAnimation("operate");
			this.canHarm = true;
			if (kind === "slow") {
				this.idTo = setTimeout(this.nextStatus.bind(this), 1500)
			} else if (kind === "fast") {
				this.idTo = setTimeout(this.nextStatus.bind(this), 750)
			} else if (kind === "double") {
				if (this.cell.spikeDouble === 0) {
					this.idTo = setTimeout(this.nextStatus.bind(this), 1000)
				} else {
					this.idTo = setTimeout(this.nextStatus.bind(this), 1500)
				}
			}
		}
		if (this.status === 2) {
			this.setAnimation("deoperate");
			setTimeout(this.resetHarm.bind(this), 100);
			if (kind === "slow") {
				this.idTo = setTimeout(this.nextStatus.bind(this), 1500)
			} else if (kind === "fast") {
				this.idTo = setTimeout(this.nextStatus.bind(this), 750)
			} else if (kind === "double") {
				if (this.cell.spikeDouble === 0) {
					this.idTo = setTimeout(this.nextStatus.bind(this), 1500)
				} else {
					this.idTo = setTimeout(this.nextStatus.bind(this), 1000)
				}
			}
		}

	}

	proxOperate() {
		this.operating = true;
		this.setAnimation("operate");
		this.idTo = setTimeout(this.proxStopOperate.bind(this), 2000)
		this.status = 1;
		this.canHarm = true;
	}

	proxStopOperate() {
		this.setAnimation("deoperate");
		this.idTo = setTimeout(this.resetOperating.bind(this), 1000);
		this.status = 2;
		setTimeout(this.resetHarm.bind(this), 100);
	}

	resetHarm() {
		this.canHarm = false;
	}

	resetOperating() {
		this.operating = false;
	}

	activateAnimation(lFlag) {
		//console.log("ATTIVO " + lFlag)
		if (lFlag) {
			if (this.status === 0) {
				this.initSpikes();
			}
			//this.spran.resume();
		} else {
			this.deinitSpikes();
			//this.spran.pause();
		}
	}
	


}
Spike.SPIKE_DAMAGE = 20;
Spike.RADIUS = 2;
Spike.ANIMATIONS = [
	{
		id: "off",
		sheet: "spikes",
		flip: false,
		frames: [
			{
				row: 0,
				col: 0,
				time: 500
			},
		]
	},
	{
		id: "operate",
		sheet: "spikes",
		flip: false,
		frames: [
			{
				row: 0,
				col: 1,
				time: 100
			},
			{
				row: 0,
				col: 2,
				time: -1
			}
		]
	},
	{
		id: "deoperate",
		sheet: "spikes",
		flip: false,
		frames: [
			{
				row: 0,
				col: 3,
				time: 100
			},
			{
				row: 0,
				col: 0,
				time: -1
			}
		]
	},
]